export default __webpack_public_path__ + "static/media/FencingLogo.89790324.png";